export default __webpack_public_path__ + "static/media/HubaboBg.c9b5676b.jpg";